<template>
  <div class="account-box ro-bind">
    <div class="ro-bind-title">未檢索到您的遊戲角色</div>
    <div class="ro-bind-tips">*請輸入與遊戲登錄相同的賬號和密碼</div>
    <label class="input-box box" :class="{ err: userAccountTips }">
      <span class="label">{{ letter.accountLabel }}：</span>
      <input
        v-model="userAccount"
        class="input"
        type="text"
        :class="{ err: userAccountTips }"
        @blur="judgeUserAccount()"
        :placeholder="letter.accountName"
      />
    </label>
    <p class="tips j-username-tip" v-if="userAccountTips">
      {{ userAccountTips }}
    </p>
    <label
      class="input-box password-box box"
      :class="{ err: userPasswordTips }"
    >
      <span class="label">{{ letter.passwordLabel }}：</span>
      <input
        v-model="userPassword"
        class="input"
        type="password"
        :class="[userPasswordTips ? 'err' : false, $platformClass]"
        @blur="judgeUserPassword()"
        :placeholder="letter.password"
      />
    </label>
    <p class="tips j-password-tip" v-if="userPasswordTips">
      {{ userPasswordTips }}
    </p>

    <div class="btn-wrap">
      <a
        href="javascript:void(0);"
        class="btn login-btn j-login-btn"
        pointClass="j-login-btn"
        :loading="loading"
        @click="roBindAccount"
      >
        <span>{{ letter.bind }}</span>
        <i v-show="loading" class="loading light" style="margin-left: 1vh"></i>
      </a>
      <p class="tips j-request-tip request-tip">{{ loginRequestTips }}</p>
    </div>
  </div>
</template>

<script type="text/javascript">
import { CHANNEL_NAME } from '../../store/web/login.js';
import login from '../../mixins/Login.js';
import globalConfig from '../../utiles/globalConfig.js';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
const mainHost = globalConfig.getMainHost();

export default {
  name: 'accountLoginPage',
  data() {
    return {
      channelName: CHANNEL_NAME,
      showThirdPart: globalConfig.getHrefParam('noThridPart') !== '1'
    };
  },
  computed: {
    gameList() {
      return this.$store.state.gameList;
    },
    gameId() {
      return this.$store.state.gameId;
    }
  },
  mixins: [login],
  mounted() {},
  methods: {
    loginHrefJump(href, target) {
      if (this.runInIframe) {
        window.parent.postMessage(
          {
            action: 'openThirdLoginLink',
            url: href
          },
          '*'
        );
      } else {
        window.open(href, target ? '_blank' : '_self');
      }
    }
  }
};
</script>

<style lang="scss">
@import '../../assets/scss/comom.scss';
@import '../../assets/scss/webLogin-v3.scss';
</style>
